import { render, staticRenderFns } from "./OtherIncomeTableUser.vue?vue&type=template&id=560cd3d6&scoped=true"
import script from "./OtherIncomeTableUser.vue?vue&type=script&lang=js"
export * from "./OtherIncomeTableUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560cd3d6",
  null
  
)

export default component.exports